import { Location, NewUser, User } from "sweet-global";

export const CREATE_USER_INIT = "user/CREATE_USER_INIT";
export const CREATE_USER_SUCCESS = "user/CREATE_USER_SUCCESS";
export const CREATE_USER_FAILURE = "user/CREATE_USER_FAILURE";
export const UPDATE_USER_INIT = "user/UPDATE_USER_INIT";
export const UPDATE_USER_SUCCESS = "user/UPDATE_USER_SUCCESS";
export const UPDATE_USER_FAILURE = "user/UPDATE_USER_FAILURE";
export const GET_USER_INIT = "user/GET_USER_INIT";
export const GET_USER_SUCCESS = "user/GET_USER_SUCCESS";
export const GET_USER_FAILURE = "user/GET_USER_FAILURE";
export const RESET_USER = "user/RESET_USER";

export interface UserState {
  entity: Partial<User>;
  isCreatingUser: boolean;
  successCreatingUser: boolean;
  errorCreatingUser: Error | null;
  isUpdatingUser: boolean;
  successUpdatingUser: boolean;
  errorUpdatingUser: Error | null;
  isGettingUser: boolean;
  successGettingUser: boolean;
  errorGettingUser: Error | null;
}

interface ResetUserAction {
  type: typeof RESET_USER;
}

interface UpdateUserInitAction {
  type: typeof UPDATE_USER_INIT;
}

interface UpdateUserSuccessAction {
  type: typeof UPDATE_USER_SUCCESS;
  user: User;
}

interface UpdateUserFailureAction {
  type: typeof UPDATE_USER_FAILURE;
  error: Error;
}

interface CreateUserInitAction {
  type: typeof CREATE_USER_INIT;
}

interface CreateUserSuccessAction {
  type: typeof CREATE_USER_SUCCESS;
  user: User;
}

interface CreateUserFailureAction {
  type: typeof CREATE_USER_FAILURE;
  error: Error;
}

interface GetUserInitAction {
  type: typeof GET_USER_INIT;
}

interface GetUserSuccessAction {
  type: typeof GET_USER_SUCCESS;
  data: User;
}

interface GetUserFailureAction {
  type: typeof GET_USER_FAILURE;
  error: Error;
}

export type UserActionTypes =
  | ResetUserAction
  | UpdateUserInitAction
  | UpdateUserSuccessAction
  | UpdateUserFailureAction
  | CreateUserInitAction
  | CreateUserSuccessAction
  | CreateUserFailureAction
  | GetUserInitAction
  | GetUserSuccessAction
  | GetUserFailureAction;
